<template>
   <div
      :class="setCardClassName"
      :style="{
         'border-radius': `${round}px`,
      }"
   >
      <div
         class="sz-card__header"
         v-if="header"
         :style="{
            'border-bottom': headerBorderNo ? 'none' : '',
            'padding-bottom': headerBorderNo ? '0' : 'inherit',
         }"
      >
         <div class="header__left">
            <slot name="header-left" />
            <div :class="setHeaderClassName">{{ title }}</div>
         </div>
         <div class="header__right">
            <slot name="header-right" />
            <div class="full-box" v-if="isShowFull">
               <vxe-button round circle icon="vxe-icon-fullscreen" v-if="!isFull" class="tool-btn" @click="changeFullFn(true)"></vxe-button>
               <vxe-button round circle icon="vxe-icon-minimize" v-else class="tool-btn" @click="changeFullFn(false)"></vxe-button>
            </div>
         </div>
      </div>
      <slot></slot>
      <slot name="card-footer" />
   </div>
</template>

<script lang="ts">
import { defineComponent, computed, PropType, ref } from "vue";
export default defineComponent({
   props: {
      /**
       * @param {String} className 传入样式名
       */
      cardClass: {
         type: String as PropType<string>,
         default: "",
      },

      /**
       * @param {String} className 传入样式名
       */
      headerClass: {
         type: String as PropType<string>,
         default: "",
      },

      /**
       * @param {String} title 标题名称
       */
      title: {
         type: String,
         default: null,
      },

      /**
       * @param {Boolean} header 显示标题
       */
      header: {
         type: Boolean,
         default: false,
      },

      /**
       * @param {String, Number} round 圆角尺寸
       */
      round: {
         type: [String, Number],
         default: 8,
      },

      /**
       * @param {String, Number} 内边距右边的距离
       */
      pr: {
         type: [Number],
         default: 24,
      },

      /**
       * @param {String, Number} 内边距左边的距离
       */

      pl: {
         type: [Number],
         default: 24,
      },

      /**
       * @param {String, Number} 内边距上边的距离
       */

      pt: {
         type: [Number],
         default: 24,
      },

      /**
       * @param {Number} 内边距下边的距离
       */
      pb: {
         type: [Number],
         default: 24,
      },

      /**
       * @param {Boolean} 头部没有border
       */
      headerBorderNo: {
         type: [Boolean],
         default: false,
      },

      /**
       * @param {Boolean} 是否展示放大缩小按钮
       */
      isShowFull: {
         type: [Boolean],
         default: false,
      },
   },
   setup(props, ctx:any) {
      //--------------------合并class--------------------

      /**
       * @method setCardClassName 合并卡片calss
       * @method setHeaderClassName 合并卡片头部calss
       */
      const isFull = ref(null);
      const fullClass = ref('');

      const setCardClassName = computed((): string[] => {
         return [fullClass.value,"sz-card", ...props.cardClass.split(" ")];
      });

      const setHeaderClassName = computed(() => {
         return ["header__left--title", ...props.headerClass.split(" ")];
      });


      const changeFullFn = (type:any)=>{
         isFull.value = type;
         fullClass.value = type?'full-screen-card':'';
      }

      return {
         setCardClassName,
         setHeaderClassName,
         changeFullFn,
         isFull,
      };
   },
});
</script>
<style lang='less' scoped>
.sz-card {
   background: #fff;
   box-sizing: border-box;
   position: relative;
   &__header {
      display: flex;
      padding: 12px 12px;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #eaecf2;
      .header__left {
         display: flex;
         align-items: center;
         &--title {
            font-size: 16px;
            line-height: 22px;
            font-weight: 600;
            margin-right: 16px;
            color: #4680ff;
         }
      }
      .header__right{
         display: flex;
         align-items: center;
         .full-box{
            margin-left: 12px;
         }
      }
   }
}
.full-screen-card{
   position: fixed;
   left: 0;
   top: 0;
   bottom: 0;
   right: 0;
   background-color: #fff;
   z-index: 1899;
}
</style>